import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import styles from './Map.module.scss';
import MapContainer from './MapContainer';

// Define interface for the props
interface MapProps {
  className?: string;
  userPosition?: { lat: number; lng: number };
  [key: string]: any;
}

interface AppState {
  app: {
    context?: {
      project?: {
        configuration?: {
          googleMap?: {
            key?: string;
          };
        };
      };
    };
  };
}

export const Map = (props: MapProps) => {
  const googleKey = useSelector((state: AppState) => state.app.context?.project?.configuration?.googleMap?.key);
  const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&v=3.exp&libraries=geometry,drawing,places`;

  return (
    <div className={clsx(styles.wrapper, props.className)}>
      <MapContainer
        /*@ts-ignore*/
        googleMapURL={googleMapURL}
        loadingElement={<div style={{ height: '100%' }} />}
        containerElement={<div style={{ height: '100%' }} />}
        mapElement={<div className={styles.element} style={{ height: '100%' }} />}
        userPosition={props.userPosition}
        {...props}
      />
    </div>
  );
};
